import * as MutationsType from "./mutationsType";
import { auth, agentsCollection } from "@/config/firebase";
import requestAxios from "@/helpers/request_axios";
import { roles } from "@/helpers/get_constants";

export default {
  async getCurrentAgent({ commit }, { uid }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/agents/${uid}`,
        method: "GET",
      });
      let data = response.data;
      let agentAuthenticated = auth.currentUser;
      commit(MutationsType.SET_AGENT, { ...data.data, ...agentAuthenticated });
      commit(MutationsType.SET_MENU_ITEMS, { role: data.data.role });
    } catch (error) {
      console.log("error", error);
      console.log(error.response);
      throw error.response.data;
    }
  },
  async getAgentById({ commit, state }, { uid }) {
    try {
      let agent = state.agents?.find((a) => a.uid === uid);
      if (!agent) {
        let response = await requestAxios({
          url: `/awy/api/v1/agents/${uid}`,
          method: "GET",
        });
        agent = response.data.data;
      }

      commit(MutationsType.SET_AGENT_SELECTED, agent);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllAgents({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/agents",
        method: "GET",
      });
      let agents = response.data.data;
      let agentsMap = agents?.reduce((prev, next) => {
        const { uid } = next;
        prev[uid] = next;
        return prev;
      }, {});
      commit(MutationsType.SET_AGENTS, agents);
      commit(MutationsType.SET_ALL_AGENTS, agents);
      commit(MutationsType.SET_ALL_AGENTS_MAP, agentsMap);
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async setAgentPerformanceReport({ commit }, { filters }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/agents/report",
        method: "GET",
        params: { filters },
      });
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveAgent({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/agents",
        method: "POST",
        data: data,
      });
      commit(MutationsType.ADD_AGENT, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateAgent({ commit, state }, { uid, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/agents/${uid}`,
        method: "PATCH",
        data: data,
      });
      let agent = response.data.data;
      commit(MutationsType.UPDATE_AGENT, agent);
      if (agent.uid === state.agent.uid) commit(MutationsType.SET_AGENT, agent);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async handleAgentHelper({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/agents/${state.agent.uid}/handle-helper`,
        method: "POST",
      });
      commit(MutationsType.UPDATE_AGENT, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async handleAgentAccount({ commit }, { uid, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/agents/${uid}/handle-account`,
        method: "POST",
        data: data,
      });
      let agent = response.data;
      commit(MutationsType.UPDATE_AGENT, agent.data);
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllIntegrations({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/agents/${state.agent.uid}/integrations`,
        method: "GET",
      });

      commit(MutationsType.SET_AGENT_INTEGRATIONS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async disconnectCalendarIntegration({ state }, { provider }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/agents/${state.agent.uid}/integrations/${provider}`,
        method: "DELETE",
      });
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async login({ commit, dispatch }, { email, password }) {
    try {
      let { user } = await auth.signInWithEmailAndPassword(email, password);

      commit(MutationsType.IS_AGENT_AUTHENTICATED, true);

      await user.getIdToken();

      // if (!user.emailVerified) throw { code: "auth/not-email-verified", message: "Correo no verificado" };

      const { claims } = await user.getIdTokenResult();
      if (claims.role) await dispatch("getCurrentAgent", { uid: user.uid });
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  // eslint-disable-next-line
  async verifyEmail({}, payload) {
    return await auth.applyActionCode(payload.code);
  },
  // eslint-disable-next-line
  async resetPassword({}, payload) {
    const email = await auth.verifyPasswordResetCode(payload.code);
    await auth.confirmPasswordReset(payload.code, payload.password);
    return email;
  },
  // eslint-disable-next-line
  async sendEmailVerification({}) {
    return await auth.currentUser.sendEmailVerification();
  },
  // eslint-disable-next-line
  async recoveryPassword({ commit }, payload) {
    try {
      await auth.sendPasswordResetEmail(payload.email);
      return true;
    } catch (error) {
      return { error: error };
    }
  },
  async logout({ dispatch }) {
    try {
      if (auth.currentUser) await auth.signOut();

      dispatch("resetModuleAgent");
      dispatch("resetModuleSubscription", { root: true });
      dispatch("resetModuleBusiness", { root: true });
      dispatch("resetModuleCatalogProduct", { root: true });
      dispatch("resetModuleCatalogCategory", { root: true });
      dispatch("resetModuleCatalogAttribute", { root: true });
      dispatch("resetModuleZones", { root: true });
      dispatch("resetPaymentMethod", { root: true });
      dispatch("resetModuleTeam", { root: true });
      dispatch("resetModuleState", { root: true });
      dispatch("resetModuleCampaignBudget", { root: true });
      dispatch("resetModuleTag", { root: true });
      dispatch("resetModuleEvent", { root: true });
      dispatch("resetModuleOrigin", { root: true });
      dispatch("resetModuleTicket", { root: true });
      dispatch("resetModuleOrder", { root: true });
      dispatch("resetModuleContact", { root: true });
      dispatch("resetModuleTimeline", { root: true });
      dispatch("resetModuleSegment", { root: true });
      dispatch("resetModuleProject", { root: true });
      dispatch("resetModuleAutomation", { root: true });
      dispatch("resetModuleLoyalty", { root: true });
      dispatch("resetModuleStore", { root: true });
      dispatch("resetModuleFiles", { root: true });
      dispatch("resetModuleChannelAssistant", { root: true });
      dispatch("resetModuleChannelWhatsApp", { root: true });
    } catch (error) {
      console.error(error);
    }
  },
  async getAllAgentsB({ commit, state }) {
    try {
      let agents = {};
      let allAgents = [];
      let allAgentsMap = {};

      const querySnapshot =
        state.agent.role === roles.ENTREPRENEUR
          ? await agentsCollection.where("team_id", "==", state.agent.team_id).get()
          : await agentsCollection.get();
      querySnapshot.forEach((doc) => {
        var data = doc.data();
        if (!data.system_agent) {
          var agent = { id: doc.id, ...data };
          allAgents.push(agent);
          allAgentsMap[agent.id] = agent;
        }
      });

      let agentsToSelect = allAgents;

      if ([roles.SUPERVISOR, roles.ENTREPRENEUR].includes(state.agent.role))
        agentsToSelect = agentsToSelect.filter((a) => a.team_id === state.agent.team_id);
      if (state.agent.role === roles.ADVISOR) agentsToSelect = agentsToSelect.filter((a) => a.id === state.agent.uid);

      for (let i = 0; i < agentsToSelect.length; i++) agents[agentsToSelect[i].id] = agentsToSelect[i];

      commit(MutationsType.SET_AGENTS, agents);
      commit(MutationsType.SET_ALL_AGENTS, allAgents);
      commit(MutationsType.SET_ALL_AGENTS_MAP, allAgentsMap);
    } catch (error) {
      console.error(error);
    }
  },
  async affiliateBusiness({ commit }, { data }) {
    try {
      const uid = auth.currentUser.uid;

      let response = await requestAxios({
        url: `/awy/api/v1/users/${uid}/affiliate-business`,
        method: "POST",
        data,
      });
      let agent = response.data.data;
      commit(MutationsType.SET_AGENT, agent);
      commit(MutationsType.SET_MENU_ITEMS, { role: agent.role });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetAgentSelected({ commit }) {
    commit(MutationsType.SET_AGENT_SELECTED, null);
  },
  resetModuleAgent({ commit }) {
    commit(MutationsType.SET_AGENT, null);
    commit(MutationsType.SET_AGENTS, null);
    commit(MutationsType.SET_ALL_AGENTS, null);
    commit(MutationsType.SET_ALL_AGENTS_MAP, null);
    commit(MutationsType.SET_AGENT_SELECTED, null);
  },
};
